export default __webpack_public_path__ + "static/media/txt1.b17d4d0d.png";